export type IToggleAriaExpander = (button: IjQueryElmOrHtmlElm) => void;

export function _toggleAriaExpander(button: IjQueryElmOrHtmlElm): void {
  const $button = $(button);
  const $elementToExpand = $(`#${$button.attr('aria-controls')}`);
  const $icon = $button.find('span');
  const isOpen = $elementToExpand.hasClass('open');

  if (isOpen) {
    $button.attr('aria-expanded', 'false');
    $icon.removeClass().addClass('fa fa-chevron-down');
    $elementToExpand.addClass('hide').attr('aria-hidden', 'true').removeClass('open');
  } else {
    $elementToExpand.removeClass('hide').attr('aria-hidden', 'false').addClass('open').focus();
    $icon.removeClass().addClass('fa fa-chevron-up');
    $button.attr('aria-expanded', 'true');
  }
}
